function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "zly7v9uuqa",
  d: "M0.154 0.157L15.359 0.157 15.359 19.764 0.154 19.764z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.132 .006)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6o5aidwbrb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#zly7v9uuqa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#77ADE4",
  d: "M15.359.954C14.355.57 12.78.157 10.817.157c-5.007 0-8.534 2.576-8.563 6.268-.029 2.73 2.517 4.252 4.439 5.16 1.972.932 2.635 1.526 2.626 2.357-.012 1.274-1.575 1.855-3.03 1.855-2.03 0-3.107-.288-4.77-.997l-.654-.302-.711 4.253c1.183.53 3.372.989 5.644 1.013 5.327 0 8.784-2.547 8.824-6.49.019-2.161-1.331-3.805-4.254-5.161-1.772-.879-2.856-1.465-2.845-2.355 0-.79.919-1.634 2.902-1.634 1.657-.026 2.857.343 3.793.728l.453.22.688-4.118",
  mask: "url(#6o5aidwbrb)",
  opacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  fill: "#77ADE4",
  d: "M52.235 12.754c.42-1.095 2.02-5.31 2.02-5.31-.03.05.415-1.1.67-1.814l.344 1.638 1.173 5.486h-4.207zM58.483.51h-3.915c-1.213 0-2.12.338-2.653 1.575L44.39 19.493h5.32s.87-2.34 1.067-2.854l6.49.008c.15.665.616 2.846.616 2.846h4.701L58.484.51zM22.048 19.487L25.216.492 30.283.492 27.113 19.487zM17.798.506l-4.96 12.953-.53-2.632c-.923-3.035-3.8-6.322-7.017-7.969l4.536 16.613 5.361-.006L23.165.505h-5.367",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#185490",
  d: "M8.235.494H.065L0 .889c6.357 1.573 10.563 5.372 12.309 9.938l-1.777-8.73C10.225.896 9.336.538 8.235.495"
}));

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 21,
    viewBox: "0 0 63 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.70bf2615.svg";
export { ForwardRef as ReactComponent };